var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pageIndex",staticClass:"root"},[_c('Navigator',{attrs:{"debugger":_vm.isDebugger,"isShowSlideBar":_vm.isShowSlideBar,"immersive":true}}),_vm._v(" "),_c('VideoPlayer',{staticClass:"bury-point",attrs:{"showid":"show_sgq90hBo"}}),_vm._v(" "),_c('Container',{ref:"Container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }